export const DeliveryStatusCode = {
    HUY_DON: 301,
    TAO_MOI: 1,
    PHAN_CONG: 261,
    TIEP_NHAN: 281,
    DANG_GIAO: 3,
    DEN_NOI: 4,
    THAT_BAI_DO_KH: 5,
    THAT_BAI_DO_HACOM: 6,
    THANH_CONG: 7,
    HUY_PHAN_CONG: 8,
    NHAP_LAI: 322,
    NHAP_LAI_MOT_PHAN: 323,
    NOI_CHUYEN: 9,
  };